var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt61(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.25 13.5431C11.25 15.8665 9.36656 17.7499 7.04322 17.7499C6.62901 17.7499 6.29322 17.4141 6.29322 16.9999C6.29322 16.5857 6.62901 16.2499 7.04322 16.2499C8.53814 16.2499 9.75001 15.038 9.75001 13.5431V12.7499H7.05556C6.08907 12.7499 5.30556 11.9664 5.30556 10.9999V7.99991C5.30556 7.03341 6.08907 6.24991 7.05556 6.24991H9.50001C10.4665 6.24991 11.25 7.03341 11.25 7.99991V13.5431ZM18.75 13.5432C18.75 15.8666 16.8666 17.75 14.5432 17.75C14.129 17.75 13.7932 17.4142 13.7932 17C13.7932 16.5858 14.129 16.25 14.5432 16.25C16.0381 16.25 17.25 15.0381 17.25 13.5432V12.75H14.5556C13.5891 12.75 12.8056 11.9665 12.8056 11V8.00001C12.8056 7.03351 13.5891 6.25001 14.5556 6.25001H17C17.9665 6.25001 18.75 7.03351 18.75 8.00001V13.5432Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt61);
export default __webpack_public_path__ + "static/media/quote-alt-6-1.07ebc804d45f1f73ad57924ebbd9d29f.svg";
export { ForwardRef as ReactComponent };